import { memo } from 'react'
import cn from 'classnames'

import type { ProgressBarProps } from './types'

import styles from './ProgressBar.module.scss'

/**
 * Линейный прогресс-бар — разрешённое исключение из правила «скелетоны вместо
 * спиннеров» (правило 14): экран расчёта натальной карты, спека 01 §7.
 */
export const ProgressBar = memo(function ProgressBar(props: ProgressBarProps) {
  const { value, isIndeterminate = false } = props
  const clamped = Math.min(100, Math.max(0, value))

  return (
    <div
      className={styles.root}
      role='progressbar'
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={isIndeterminate ? undefined : clamped}
    >
      <div
        className={cn(styles.fill, isIndeterminate && styles.isIndeterminate)}
        style={isIndeterminate ? undefined : { width: `${clamped}%` }}
      />
    </div>
  )
})
